module.exports = __webpack_public_path__ + "img/no-photo2.c68ccc5b.png";